import {BASE_URL} from '../../api'
import config from '../config'

const {axios} = config
const useAdmin = () => {
  const updateAdminPassword = async (id: any, currentPassword: string, newPassword: string) => {
    try {
      const {data, status} = await axios.put(`${BASE_URL}/admin/${id}/update-password`, {
        currentPassword: currentPassword,
        newPassword: newPassword,
      })

      return {data, status}
    } catch (err: any) {
      throw new Error(err)
    }
  }

  return {updateAdminPassword}
}

export default useAdmin
